exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-invite-[code]-tsx": () => import("./../../../src/pages/invite/[code].tsx" /* webpackChunkName: "component---src-pages-invite-[code]-tsx" */),
  "component---src-pages-svg-tsx": () => import("./../../../src/pages/svg.tsx" /* webpackChunkName: "component---src-pages-svg-tsx" */)
}

